import React, { useEffect, useState } from 'react'
import LandingFooter from '../components/LandingFooter'
import NavigationBar from '../components/NavigationBar'
import { MDBAlert, MDBCol, MDBContainer, MDBRow, MDBDatepicker, MDBTimepicker } from 'mdb-react-ui-kit'
import { Demo } from '../assets/images/images'
import TimezoneSelect from 'react-timezone-select'
import { createDemo } from '../../services/apiServices'
import { isEmail, isEmpty } from '../../validators/helper'

const ScheduleaDemo = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        fname: '',
        lname: '',
        email: '',
        date: '',
        time: '',
        inquiry: '',
        timezone: { value: 'Asia/Kolkata' },
        businessname: "",
    });
    const [Alerttxt, setAlerttxt] = useState("");
    const [ErrorContactInfo, setErrorContactInfo] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    useEffect(() => {
        let date = new Date();
        date.setMinutes(date.getMinutes() + 20); // add 20 minutes

        // Format time as HH:mm
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const time = `${hours}:${minutes}`;

        // Format date as DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
        const year = date.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;

        setFormData(prev => ({
            ...prev,
            time: time,
            date: formattedDate
        }));
    }, []);

    const handleDateChange = (value) => {
        setFormData(prev => ({ ...prev, date: value }));
    };

    const handleTimeChange = (value) => {
        setFormData(prev => ({ ...prev, time: value.target.value }));
    };

    const handleTimeZoneChange = (value) => {
        setFormData(prev => ({ ...prev, timezone: value }));
    };
    let validateForm = () => {
        let errors = {};
        if (isEmpty(formData.fname)) {
            errors.fname = "Name can't be blank";
        }
        if (isEmpty(formData.lname)) {
            errors.lname = "Name can't be blank";
        }
        if (isEmpty(formData.date)) {
            errors.date = "Date can't be blank";
        }
        if (isEmpty(formData.time)) {
            errors.time = "Time can't be blank";
        }
        if (isEmpty(formData.email)) {
            errors.email = "Field can't be blank";
        } else if (!isEmail(formData.email)) {
            errors.email = "Please enter valid email";
        }

        if (isEmpty(formData.businessname)) {
            errors.businessname = "Field can't be blank";
        }
        // if (isEmpty(formData.subject)) {
        //     errors.subject = "Subject can't be blank";
        // }

        if (isEmpty(formData.inquiry)) {
            errors.inquiry = "Text can't be blank";
        }
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };
    const handleSubmit = async () => {
        try {
            console.log(formData);
            let errors = validateForm();
            console.log(errors);
            if (errors === true) {
                setErrorContactInfo({});
                const res = await createDemo(formData);
                if (!res || res === "false") {
                    return;
                }
                if (res.status == 200) {
                    setAlerttxt("Demo Booked Successfully.")
                }
            } else {
                setErrorContactInfo(errors);
            }
            setFormData({
                fname: '',
                lname: '',
                email: '',
                date: '',
                time: '',
                inquiry: '',
                timezone: { value: 'Asia/Kolkata' },
                businessname: "",
            });
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form.');
        }
    };
    return (
        <>
            <NavigationBar classText='blue-logo' />
            <div className="lp">
                <div className="home-section">
                    <MDBContainer>
                        <MDBRow className='sm-demo'>
                            <MDBCol sm='12' md='5' className='lp_demo-leftcol position-relative lp_bgimg' >
                                <img src={Demo} alt="" />
                                <div className='lp_textcontent'>
                                    {/* <h2>Experience EasyMember in Action</h2> */}
                                    <p>Discover how EasyMember simplifies <br /> membership management...</p>
                                </div>
                            </MDBCol>
                            <MDBCol sm='12' md='7' className='demo-rightcol'>
                                <div class="card">
                                    <div class="card-body">
                                        <h3 class="text-center">Book
                                            a
                                            Demo</h3>
                                        <p class="card-text text-center">Share your details and let’s prioritize your convenience! We’ll reach out at your preferred time.</p>
                                        <div>
                                            <MDBRow>
                                                <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text dived" id="addon-wrapping"><i class="fas fa-user"></i></span>
                                                        <input type="text" class="form-control" placeholder="First Name" aria-label="firstname"
                                                            name="fname"
                                                            value={formData.fname}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    {ErrorContactInfo.fname && (<p className="text-danger">{ErrorContactInfo.fname}</p>)}
                                                </MDBCol>
                                                <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text dived" id="addon-wrapping"><i class="fas fa-user"></i></span>
                                                        <input type="text" class="form-control" placeholder="Last Name" aria-label="lastname"
                                                            name="lname"
                                                            value={formData.lname}
                                                            onChange={handleChange} />
                                                    </div>
                                                    {ErrorContactInfo.lname && (<p className="text-danger">{ErrorContactInfo.lname}</p>)}
                                                </MDBCol>
                                                <MDBCol sm='12' md='12'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text dived" id="addon-wrapping"><i class="fas fa-envelope"></i></span>
                                                        <input type="text" class="form-control" placeholder="E-mail" aria-label="E-mail"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange} />
                                                    </div>
                                                    {ErrorContactInfo.email && (<p className="text-danger">{ErrorContactInfo.email}</p>)}
                                                </MDBCol>

                                                <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text" id="addon-wrapping"><i class="fas fa-briefcase"></i></span>
                                                        <input type="text" class="form-control" placeholder="Business Name" aria-label="lastname"
                                                            name="businessname"
                                                            value={formData.businessname}
                                                            onChange={handleChange} />
                                                    </div>
                                                    {ErrorContactInfo.businessname && (<p className="text-danger">{ErrorContactInfo.businessname}</p>)}
                                                </MDBCol>
                                                <MDBCol sm='12' md='6' className='mb-3'>
                                                    <TimezoneSelect
                                                        placeholder="Select Time Zone"
                                                        className="label-offset mob-w-100 mob-block"
                                                        value={formData.timezone}
                                                        onChange={handleTimeZoneChange}
                                                    />
                                                </MDBCol>
                                                <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text" id="addon-wrapping"><i class="fas fa-calendar-alt"></i></span>
                                                        <MDBDatepicker
                                                            value={formData.date}
                                                            onChange={(date) => handleDateChange(date)}
                                                            disablePast
                                                            inputToggle
                                                            selectOnClick
                                                        />
                                                        {/* <input type="date" class="form-control" placeholder="Date" aria-label="lastname" /> */}
                                                    </div>
                                                </MDBCol>
                                                {/* <MDBCol sm='12' md='6'>
                                                        <div class="input-group input-group-lg mb-3">
                                                            <span class="input-group-text" id="addon-wrapping"><i class="fas fa-calendar-alt"></i></span>
                                                            <input type="date" class="form-control" placeholder="Date" aria-label="lastname" />
                                                        </div>
                                                    </MDBCol> */}

                                                <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text" id="addon-wrapping"><i class="far fa-clock"></i></span>
                                                        <input type="time" class="form-control" placeholder="Time" aria-label="lastname"
                                                            value={formData.time}
                                                            onChange={(time) => handleTimeChange(time)}
                                                        />
                                                    </div>
                                                </MDBCol>


                                                <div class=" mb-3">
                                                    <textarea class="form-control" id="validationTextarea" rows={3} placeholder="Inquiry... "
                                                        name="inquiry"
                                                        value={formData.inquiry}
                                                        onChange={handleChange}></textarea>
                                                    {ErrorContactInfo.inquiry && (<p className="text-danger">{ErrorContactInfo.inquiry}</p>)}
                                                </div>
                                                <div >
                                                    <div class="form-check align-items-start">
                                                        <input class="form-check-input mt-1" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label class="form-check-label" for="flexCheckDefault">By submitting this form, I confirm that I have read and understood <span class="lp_revenue_header"> <a href='/privacypolicy' className='p-0'> privacy policy</a> </span> .</label>
                                                    </div>
                                                    <div className='d-flex align-items-end justify-content-end'>
                                                        <button className='my-3 lp_btn lp_btnsm lp_fillbtn ' color='primary' onClick={handleSubmit}>
                                                            Submit
                                                        </button>
                                                    </div>

                                                </div>
                                            </MDBRow>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </div>

                <div className='my-5'>
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol sm='12' md='4' className='mb-2'>
                                <div className='card text-center shadow-0 border lp_demofooter h-100'>
                                    <div className='card-body'>
                                        <i className='bi bi-whatsapp'> </i>
                                        <div className='mb-5'>
                                            <h4>WhatsApp Us</h4>
                                            <p className='mb-0'>Chat to our expert</p>
                                            <p className='connect-link'><a href='https://wa.me/918019296262' target='_blank' rel='noopener noreferrer'>
                                                +91 8019296262
                                            </a></p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol sm='12' md='4' className='mb-2'>
                                <div className='card text-center shadow-0 border lp_demofooter h-100'>
                                    <div className='card-body'>
                                        <i className='bi bi-telephone'> </i>
                                        <div className='mb-5'>
                                            <h4>Call us</h4>
                                            <p className='mb-0'>Speak to our expert</p>
                                            <p className=''>+91 8019296262</p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol sm='12' md='4' className='mb-2'>
                                <div className='card text-center shadow-0 border lp_demofooter h-100'>
                                    <div className='card-body'>
                                        <i className='bi bi-envelope'> </i>
                                        <div className='mb-5'>
                                            <h4>Email us</h4>
                                            <p className='mb-0'>Connect with our dedicated support team</p>
                                            <p className='connect-link'> <a href='mailto:contact@easymembr.com' target='_blank'>contact@easymembr.com</a></p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </div>
            </div>
            <MDBAlert
                color={Alerttxt.includes("Failed") ? "danger" : "success"}
                autohide
                position='top-right'
                delay={4000}
                appendToBody
                open={Alerttxt != ""}
                onClose={() => setAlerttxt("")}
            >
                {Alerttxt}
            </MDBAlert>

            <LandingFooter from={"demo"} />
        </>
    )
}

export default ScheduleaDemo
